module.exports = {"Arabic":"ar","Farsi (Persian)":"fa","Hausa":"ha","Hebrew":"he","Pashto":"ps","Urdu":"ur"}